import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_POLICY_PLANS = 'GET_POLICY_PLANS';

export const service = async () => {
  const options: object = {
      url: `/Api/PolicySearch/GetPolicyPlans`,
    method: "GET",
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_POLICY_PLANS, service, mock);